import React from "react";
import Chip from "@mui/material/Chip";
import { useAtom } from "jotai";
import { themeAtom, labelsAtom, labelColoursAtom } from "../-Atoms";

const LabelChip = ({ label, setLabelMenuOpen, kanbanBoard }) => {
  const [theme] = useAtom(themeAtom);
  const [labels] = useAtom(labelsAtom);
  const [labelColours] = useAtom(labelColoursAtom);

  let labelData = {};
  labels.forEach((l) => {
    if (l.id === label) {
      labelData = l;
    }
  });

  const isHidden = () => {
    if (kanbanBoard && !labelData.color) return true;
    if (kanbanBoard && labelData.kanbanHidden) return true;
    return false;
  };

  return (
    <>
      {isHidden() ? null : (
        <Chip
          label={labelData.name}
          size="small"
          onClick={() => setLabelMenuOpen(true)}
          sx={{
            backgroundColor: labelData.color
              ? labelColours[labelData.color][theme]
              : "rgba(0, 0, 0, 0.4)",
            height: kanbanBoard ? "auto" : 32,
            fontSize: kanbanBoard ? "0.6875rem" : "0.75rem",
            fontWeight: 600,
            color: "white",
            borderRadius: kanbanBoard ? 1 : 2,
            margin: kanbanBoard ? 0 : 0.25,
            marginRight: kanbanBoard ? 1 : 0.5,
            marginBottom: kanbanBoard ? 1 : 0.25,
            boxShadow: kanbanBoard 
              ? "none" 
              : (theme === "dark" 
                  ? "0 2px 8px rgba(0,0,0,0.3)" 
                  : "0 2px 8px rgba(0,0,0,0.15)"),
            transition: "all 0.2s ease-in-out",
            cursor: "pointer",
            "& .MuiChip-label": {
              paddingLeft: kanbanBoard ? "8px" : "12px",
              paddingRight: kanbanBoard ? "8px" : "12px",
              fontSize: kanbanBoard ? "0.6875rem" : "0.75rem",
              fontWeight: 600,
            },
            "&:hover": {
              backgroundColor: kanbanBoard
                ? labelData.color
                  ? labelColours[labelData.color][theme]
                  : "rgba(0, 0, 0, 0.2)"
                : newShade(
                    labelData.color
                      ? labelColours[labelData.color][theme]
                      : "rgba(0, 0, 0, 0.2)",
                    theme === "dark" ? -30 : 30
                  ),
              transform: kanbanBoard ? "none" : "translateY(-1px)",
              boxShadow: kanbanBoard 
                ? "none" 
                : (theme === "dark" 
                    ? "0 4px 12px rgba(0,0,0,0.4)" 
                    : "0 4px 12px rgba(0,0,0,0.2)"),
            },
          }}
        />
      )}
    </>
  );
};

export default LabelChip;

const newShade = (hexColor, magnitude) => {
  if (!hexColor || typeof hexColor !== 'string') return '#000000';
  hexColor = hexColor.replace(`#`, ``);
  if (hexColor.length === 6) {
    const decimalColor = parseInt(hexColor, 16);
    let r = (decimalColor >> 16) + magnitude;
    r > 255 && (r = 255);
    r < 0 && (r = 0);
    let g = (decimalColor & 0x0000ff) + magnitude;
    g > 255 && (g = 255);
    g < 0 && (g = 0);
    let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
    b > 255 && (b = 255);
    b < 0 && (b = 0);
    return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
  } else {
    return hexColor;
  }
};
